import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

const ConsumerNavbar = ({ user }: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { businessName, carrierCanonicalId } = useParams();
  const handleLogout = () => {
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("authToken");
    navigate(`/${businessName}/${carrierCanonicalId}/consumer-login`);
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        padding: isMobile ? "0 20px" : "0 40px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: isMobile ? "center" : "space-between",
          padding: "20px 0",
        }}
      >
        <Box>
          {!isMobile && (
            <Typography variant="h5" sx={{ color: "#2e3a59" }}>
              Your Move Dashboard
            </Typography>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant={isMobile ? "body2" : "body1"}
            sx={{ color: "#4a4a4a", textAlign: isMobile ? "center" : "right" }}
          >
            Welcome{" "}
            <strong>
              {user?.first_name} {user?.last_name}
            </strong>
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleLogout}
              sx={{
                marginLeft: "20px",
                borderRadius: "5px",
                padding: "8px 16px",
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ConsumerNavbar;
